<template>
  <h-frame type="right" v-model:defaultOpen="defaultOpen">
    <div class="drugControlModelRight">
      <div class="itemDetail first">
        <drugrighzero></drugrighzero>
      </div>
      <div class="itemDetail second">
        <x-title>
          <div class="titleWidth">
            活动趋势
            <div class="titleMore" @click="personClick">更多</div>
          </div>
        </x-title>
        <drugrightone></drugrightone>
      </div>
      <div class="itemDetail three">
        <x-title>
          <div class="titleWidth">
            频繁出没人员
            <div class="titleMore" @click="personClick">更多</div>
          </div>
        </x-title>
        <drugrighttwo
          ref="childreftwo"
          class="content"
          :timeData="timeData"
        ></drugrighttwo>
      </div>
      <div class="itemDetail three">
        <x-title>
          <div class="titleWidth">
            疑似离开
            <div class="titleMore" @click="leaveClick">更多</div>
          </div>
        </x-title>
        <drugrightthree
          ref="childref"
          class="content"
          :timeData="timeData"
        ></drugrightthree>
      </div>
    </div>
    <el-dialog v-model="formVisible" title="频繁出没" width="73%">
      <moreDrugrighttwo
        v-if="formVisible"
        :outList="outList"
      ></moreDrugrighttwo>
    </el-dialog>
    <el-dialog v-model="leaveVisible" title="疑似离开" width="50%">
      <moreLeaveDialog
        v-if="leaveVisible"
        :outList="leaveList"
      ></moreLeaveDialog>
    </el-dialog>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
// import * as echarts from "echarts";
// import labelLegend from './labelLegend';
// import {
//   securitylist,
//   strengthlist,
//   equipmentlist
// } from "@/api/threeSolid/threeSolidHome.js";
import drugrighzero from "./drugrighzero";
import drugrightone from "./drugrightone";
import drugrighttwo from "./drugrighttwo";
import drugrightthree from "./drugrightthree";
import moreDrugrighttwo from "./moreDrugrighttwo";
import moreLeaveDialog from "./moreLeaveDialog";
export default defineComponent({
  name: "",
  components: {
    drugrighzero,
    drugrightone,
    drugrighttwo,
    drugrightthree,
    moreDrugrighttwo,
    moreLeaveDialog,
  },
  props: {
    timeData: {
      type: Object,
    },
  },
  setup(props, context) {
    const data = reactive({
      formVisible: false,
      leaveVisible: false,
      outList: {},
      leaveList: {},
      defaultOpen: true,
    });
    const refData = toRefs(data);
    const childref = ref();
    const childreftwo = ref();
    watchEffect(() => {
      context.emit("changeDefaultOpen", data.defaultOpen);
    });
    const personClick = () => {
      data.formVisible = true;
    };
    const leaveClick = () => {
      data.leaveVisible = true;
    };
    const childone = (timedata, datatime) => {
      data.outList = timedata;
      data.leaveList = datatime;

      childreftwo.value && childreftwo.value.numberall(timedata);
      childref.value && childref.value.numberall(datatime);
      // datatime疑似离开
    };

    return {
      ...refData,
      personClick,
      leaveClick,
      childone,
      childref,
      childreftwo,
    };
  },
});
</script>
<style lang="scss" scoped>
.drugControlModelRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: hidden;

  .itemDetail.first {
    height: 115px;
  }

  .itemDetail.second {
    height: 35%;

    .content {
      height: calc(100% - 36px);
    }
  }

  .itemDetail.three {
    height: calc((65% - 115px) / 2);

    .content {
      height: calc(100% - 36px);
    }
  }

  .titleWidth {
    width: 100%;
  }

  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 14px;
  }

  .titleYellow {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }

  .rightItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;

    .leftpeople {
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: column;

      // margin-bottom: 20px;
      .yellowColor {
        width: 100%;
        text-align: center;
        color: #f3ce61;
        line-height: 40px;
      }

      .peopleecharts {
        display: flex;
        flex-direction: column;

        .oneBox {
          display: flex;
          justify-content: space-between;
          line-height: 30px;

          .bluecolore {
            color: #91c8ff;
          }
        }

        .oneBluebg {
          width: 100%;
          height: 30px;
          background: rgba(0, 143, 187, 1);
          border-radius: 4px;
          position: relative;

          .bluecount {
            width: 200px;
            text-align: center;
            height: 100%;
            position: absolute;
            border-radius: 4px;
            box-shadow: 0 0 10px 3px #00c9fa inset;
            background: #00a8ec;
            z-index: 2;
            line-height: 30px;
          }

          .noBlue {
            position: absolute;
            right: 20px;
            line-height: 30px;
          }
        }
      }
    }

    .rightspecial {
      flex-wrap: wrap;
      display: flex;
      justify-content: space-around;
      padding: 20px 36px;
    }

    .itemList {
      width: 81px;
      height: 72px;
      display: flex;
      flex-direction: column;
      background-image: url("~@/assets/images/home/yujing.png");
      text-align: center;
      margin-bottom: 24px;

      .itenSize {
        margin-top: 18px;
        margin-bottom: 35px;
      }
    }
  }

  .event {
    width: 100%;
    display: flex;
    flex-direction: column;

    // margin-bottom: 15px;
    .eventTop {
      display: flex;
      margin: 15px 0;
      justify-content: space-around;

      .topItem {
        display: flex;
      }

      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }

      .topRight {
        display: flex;
        flex-direction: column;

        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
        }
      }
    }
  }

  .echarts {
    width: 100%;
    height: 180px;
  }

  .blueColor {
    color: #73f1f3;
  }

  .moreSelect {
    position: absolute;
    bottom: 24px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }

  .downBtn {
    padding: 3px 5px;
    background: rgba(0, 0, 0, 0.5);
    // border-radius: 5px;
    position: absolute;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }
}
</style>
